import Vuex from 'vuex';
import homeTextContent from './modules/home-text-content'
import gallery from './modules/gallery'
import footer from './modules/footer'
import locations from './modules/locations'
import toggleMobileNav from './modules/toggle-mobile-navigation'
import events from './modules/events'
import auth from './modules/auth'
import bookEvents from './modules/book-events'
import myEvents from './modules/my-events'
import counter from './modules/counter'
import upcomingEvents from './modules/upcoming-events'
import updateProfile from './modules/update-profile'
import AppHooperImageSlider from "@/components/AppHooperImageSlider"
import MasonryLayout from "@/components/MasonryLayout";

import Vue from 'vue'



/**
 * Load all store modules
 * @return {any} The store config
 */
function loadStore() {
  return {
    homeTextContent,
    gallery,
    footer,
    locations,
    toggleMobileNav,
    events,
    auth,
    bookEvents,
    myEvents,
    counter,
    upcomingEvents,
    updateProfile
  };
}

/**
 * Create the store instance
 * @param {object} options - Pass in any additional middleware.
 * @return {Vuex.Store} The newly created vuex store
 */
function createStore({ plugins, strict } = {}) {
  Vue.component('app-hooper-image-slider', AppHooperImageSlider);
  Vue.component('masonry-layout', MasonryLayout);
  return new Vuex.Store({
    modules: loadStore(),
    plugins,
    strict,
  });
}

/**
 * Initialize vuex
 * @return {Vuex.Store} The newly created vuex store
 */
export function init() {
  const strict = process.env.NODE_ENV !== 'production';
  return createStore({ strict });
}
